import { useDispatch, useSelector } from "react-redux";
import i18n from "examsbook-react-sdk/translations";
import { getUser, updateUser } from "examsbook-react-sdk/actions/getUser";

/**
 * Hook to set default language of user.
 * this returns language and setter.
 * @returns {{defaultLanguage: (*|string), setUserLanguage: setUserLanguage}}
 */
export default function useUserLanguage() {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const userId = user?.user?._id ? user?.user?._id : user?._id;
    const userLanguage = user?.user?.language ? user?.user?.language : user?.language;
    const storedLanguage = localStorage.getItem("language");
    const language = storedLanguage !=="null" ? storedLanguage : userLanguage;

    function setUserLanguage(lang) {
        if (!lang) return;
        localStorage.setItem("language", lang);
        i18n.changeLanguage(lang);
        dispatch(updateUser(userId, { language: lang }));
        if(window.location.pathname === "/my-profile") {
            dispatch(getUser());
        }
    }

    return { language, setUserLanguage };
}
